// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"47":"client","818":"auth"}[chunkId] + "." + {"47":"0e91d199","818":"57d9c569"}[chunkId] + ".css";
};